import { render, staticRenderFns } from "./PrescriptionConfig.vue?vue&type=template&id=4f5d03c6&scoped=true"
import script from "./PrescriptionConfig.vue?vue&type=script&lang=js"
export * from "./PrescriptionConfig.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionConfig.vue?vue&type=style&index=0&id=4f5d03c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d03c6",
  null
  
)

export default component.exports